/* Custom script to swap card media, title, price, micro-description and Yotpo rating when a sibling swatch is clicked on collection-grid cards */
window.SiblingSwatchUpdater = window.SiblingSwatchUpdater || {
  initialized: false,
  selectors: {
    group: '.product__siblings',
    link: '.sibling__link',
    card: '.product-card-wrapper',
    mediaImg: '.card__media img',
    titleLink: '.card__heading a',
    priceMobile: '.price--mobile',
    priceDesktop: '.price--desktop',
    microDescription: '.micro-description',
    yotpoWidget: '.yotpo-widget-instance',
  },

  init(context = document) {
    const groups = context.querySelectorAll(this.selectors.group);
    if (!groups.length) return;

    groups.forEach((group) => {
      if (group.dataset.siblingBound === 'true') return;
      group.dataset.siblingBound = 'true';

      group.addEventListener('click', (event) => {
        const link = event.target.closest(this.selectors.link);
        if (!link || !group.contains(link)) return;

        const card = link.closest(this.selectors.card);
        if (!card) return;

        event.preventDefault();
        this.applySibling(card, link);
      });
    });
  },

  applySibling(card, link) {
    const baseProductUrl = card.dataset.productUrl;
    const newUrl = link.href;

    card.querySelectorAll(`${this.selectors.link}--current`).forEach((activeLink) => {
      activeLink.classList.remove('sibling__link--current');
    });
    link.classList.add('sibling__link--current');

    const mediaImgs = card.querySelectorAll(this.selectors.mediaImg);
    const [primaryImg, secondaryImg] = mediaImgs;

    const newSrc = link.dataset.siblingImageSrc;
    const newSrcset = link.dataset.siblingImageSrcset;
    if (primaryImg && newSrc) {
      primaryImg.src = newSrc;
      if (newSrcset) primaryImg.srcset = newSrcset;
    }

    const newSecondarySrc = link.dataset.siblingSecondaryImageSrc;
    const newSecondarySrcset = link.dataset.siblingSecondaryImageSrcset;
    if (secondaryImg && newSecondarySrc) {
      secondaryImg.src = newSecondarySrc;
      secondaryImg.srcset = newSecondarySrcset || '';
    }

    const titleLink = card.querySelector(this.selectors.titleLink);
    if (titleLink && link.dataset.siblingTitle) {
      titleLink.textContent = link.dataset.siblingTitle;
    }

    const priceMobile = card.querySelector(this.selectors.priceMobile);
    if (priceMobile && link.dataset.siblingPriceMobile) {
      priceMobile.outerHTML = link.dataset.siblingPriceMobile;
    }

    const priceDesktop = card.querySelector(this.selectors.priceDesktop);
    if (priceDesktop && link.dataset.siblingPriceDesktop) {
      priceDesktop.outerHTML = link.dataset.siblingPriceDesktop;
    }

    const newMicroDescription = link.dataset.siblingMicroDescription || '';
    let microDescription = card.querySelector(this.selectors.microDescription);
    if (!microDescription && newMicroDescription && titleLink) {
      const heading = titleLink.closest('.card__heading') || titleLink;
      microDescription = document.createElement('span');
      microDescription.className = 'micro-description';
      heading.insertAdjacentElement('afterend', microDescription);
    }
    if (microDescription) {
      microDescription.innerHTML = newMicroDescription;
    }

    const yotpoWidget = card.querySelector(this.selectors.yotpoWidget);
    const yotpoWrapper = yotpoWidget && yotpoWidget.closest('a');
    if (yotpoWrapper && link.dataset.siblingYotpo) {

      yotpoWrapper.outerHTML = link.dataset.siblingYotpo;
      if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
        window.yotpo.refreshWidgets();
      }
    }

    if (newUrl) {
      card.dataset.productUrl = newUrl;
      card.querySelectorAll(`a[href^="${baseProductUrl}"]`).forEach((a) => {
        a.href = newUrl;
      });
    }
  },
};


document.addEventListener('DOMContentLoaded', () => {
  SiblingSwatchUpdater.init();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.matches && node.matches(SiblingSwatchUpdater.selectors.group)) {
            SiblingSwatchUpdater.init(node);
          } else if (node.querySelector && node.querySelector(SiblingSwatchUpdater.selectors.group)) {
            SiblingSwatchUpdater.init(node);
          }
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
